import React from "react";
import { Edit as EditIcon, Delete as DeleteIcon, PublishedWithChangesRounded, } from "@mui/icons-material"; import { useEffect, useState } from "react";
import axios from "axios";
import { Autocomplete, Box, Button, Card, CardContent, CardHeader, Checkbox, FormControl, FormControlLabel, Grid, IconButton, MenuItem, TextField, Tooltip, Typography, } from "@mui/material";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import Modal from "@mui/material/Modal";
import { catalogoSave, catalogoDelete, catalogoUpdate } from "../../../services/CatalogoServices";
import BreadcrumbBar from "../../../layout/BreadcrumbBar";
import MUIXDataGrid from "../../Ayuda/MUIXDataGrid";
import { crudService } from "../../../services/CrudService";
import { ZonaEnum } from "../../../types/enumTypes";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  bgcolor: "background.paper",
  boxShadow: 5,
  p: 2,
};

export default function Enlaces() {
  const TITULO = "Catálogo de Enlaces";
  const TITULODETALLE = "Detalle de Enlaces";
  const BASEURL = `catalogos/enlaces`;
  document.title = TITULO;

  const navigate = useNavigate();
  const [id, setid] = useState("");
  const [texto, setTexto] = useState("");
  const [link, setLink] = useState("");
  const [zona, setZona] = useState<string | null>(null); // Estado para múltiples roles
  const [es_icono, setEs_icono] = useState(false);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleSave = async () => {
    try {
      const newPublicacion = { link, texto, es_icono, zona };
     

      await crudService(BASEURL, 'crear', null, newPublicacion).then(
        () => window.location.reload()
      )
    } catch (error) {
      console.error("Error al crear Enlace:", error);
    }
  };
  const handleDelete = async (id: string) => {
    Swal.fire({
      icon: "warning",
      title: "Dar de baja",
      text: "¿Estás seguro de que deseas dar de baja este Enlace?",
      showCancelButton: true,
      confirmButtonColor: "#15212f",
      cancelButtonColor: "#bda889",
      confirmButtonText: "Confirmar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await crudService(BASEURL, "baja", id);
          if (response.success) {
            Swal.fire({
              icon: "success",
              title: "Baja",
              text: "El Enlace ha sido dada de baja.",
              confirmButtonColor: "#15212f",
            }).then(() => {
              window.location.reload();
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: response.message || "No se pudo dar de baja el Enlace.",
              confirmButtonColor: "#15212f",
            });
          }
        } catch (error) {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "No se pudo dar de baja el Enlace.",
            confirmButtonColor: "#15212f",
          });
        }
      }
    });
  };

  const handleRecover = async (id: string) => {
    Swal.fire({
      icon: "info",
      title: "Recuperar",
      text: "¿Estás seguro de que deseas recuperar este Enlace?",
      showCancelButton: true,
      confirmButtonColor: "#15212f",
      cancelButtonColor: "#bda889",
      confirmButtonText: "Confirmar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await crudService(BASEURL, "recupera", id);
          if (response.success) {
            Swal.fire({
              icon: "success",
              title: "Recuperado",
              text: "El Enlace ha sido recuperada.",
              confirmButtonColor: "#15212f",
            }).then(() => {
              window.location.reload();
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Error",
              text: response.message || "No se pudo recuperar el Enlace.",
              confirmButtonColor: "#15212f",
            });
          }
        } catch (error) {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "No se pudo recuperar el Enlace.",
            confirmButtonColor: "#15212f",
          });
        }
      }
    });
  };
  const handleUpdate = async () => {
    if (texto === "") {
      Swal.fire({
        icon: "error",
        title: "¡Error!",
        text: "Favor de completar los campos",
        confirmButtonColor: "#15212f",
      });
    } else {
      try {
        const data = { texto, link, es_icono, zona }
        const response = await crudService(BASEURL, "actualizar", id, data);
        if (response.success) {
          Swal.fire({
            icon: "success",
            title: "Recuperado",
            text: "El Enlace ha sido actualizada.",
            confirmButtonColor: "#15212f",
          }).then(() => {
            window.location.reload();
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: response.message || "No se pudo actualizar el Enlace.",
            confirmButtonColor: "#15212f",
          });
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "No se pudo actualizar el Enlace.",
          confirmButtonColor: "#15212f",
        });
      }
    }
  };

  const columns = [
    {
      field: "acciones",
      headerName: "Acciones",
      width: 180,
      headerAlign: "left",
      hideable: false,
      renderCell: (cellValues: any) => {
        return (
          <Box>
            <Tooltip title={"Editar"}>
              <IconButton color="inherit"
                onClick={() => {
                  setid(cellValues.row.id);
                  setTexto(cellValues.row.texto);
                  setLink(cellValues.row.link);
                  setEs_icono(cellValues.row.es_icono);
                  setZona(Array.isArray(cellValues.row.zona) ? cellValues.row.zona : (typeof cellValues.row.zona === 'string' ? cellValues.row.zona.split(',') : []));
                  handleOpen();
                }}
              >
                <EditIcon />
              </IconButton>
            </Tooltip>
            {
              cellValues.row.estatus == 'ACTIVO' ?
                <Tooltip title={"Eliminar"}>
                  <IconButton color="inherit"
                    onClick={() => { handleDelete(cellValues.row.id); }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </Tooltip>
                :
                <Tooltip title={"Recuperar"}>
                  <IconButton color="inherit"
                    onClick={() => { handleRecover(cellValues.row.id); }}
                  >
                    <PublishedWithChangesRounded />
                  </IconButton>
                </Tooltip>
            }
          </Box>
        );
      },
    },
    {
      field: "texto",
      headerName: "Texto",
      width: 200,
      hideable: false,
      headerAlign: "left",
    },
    {
      field: "link",
      headerName: "Link",
      width: 300,
      hideable: false,
      headerAlign: "left",
    },
    {
      field: "es_icono",
      headerName: "Es Icono",
      width: 150,
      hideable: false,
      headerAlign: "left",
    },
    {
      field: "zona",
      headerName: "Zona",
      width: 150,
      hideable: false,
      headerAlign: "left",
    },
    {
      field: "estatus",
      headerName: "Estatus",
      width: 650,
      hideable: false,
      headerAlign: "left",
    },
  ];
  const camposCsv = ["Cve", "nombre", "estatus"];
  const [rows, setRows] = useState([]);
  const getAllEnlaces = async () => {
    const response = await crudService(BASEURL, 'obtener');
    if (response?.data) {
      setRows(response.data)
    }
  };

  useEffect(() => {
    getAllEnlaces();
  }, []);

  useEffect(() => {
    // Limpieza de campos al cerrar la modal
    if (!open) {
      setTexto("");
      setLink("");
      setEs_icono(false);
      setZona("");

    }
  }, [open]);
  return (
    <Grid container sx={{}}>
      <BreadcrumbBar
        links={[
          { texto: 'Inicio', link: '/admin' },
          { texto: 'Catálogos', link: '/admin/catalogos' }
        ]
        }
        Titulo={TITULO}
      />
      <Grid container xs={12} justifyContent={"center"}>
        <Grid item xs={12} md={12} mt={2}>
          <Card sx={{ p: 0, boxShadow: 8 }}>
            <CardHeader sx={{ position: "absolute", fontFamily: "MontserratSemiBold" }} />
            <Typography variant="h5" sx={{ paddingTop: "1%", paddingLeft: "1%" }}>  {TITULO} </Typography>
            <CardContent sx={{ fontFamily: "MontserratBold", bgcolor: "" }}>
              <Box display="flex" justifyContent="flex-end">
                <Grid
                  sx={{
                    display: "flex",
                    alignItems: "right",
                    justifyContent: "right",
                    paddingBottom: "2%",
                    paddingRight: "1%",
                  }}
                >
                  <Button
                    onClick={handleOpen}
                    variant="contained"
                    sx={{ margin: "1%", color: "#FFFFFF" }}
                  >
                    <Typography
                      sx={{
                        color: "#FFFFFF", "&:hover": { color: "#15212f" },
                        fontFamily: "MontserratRegular, sans-serif",
                        fontSize: "100%",
                      }}
                    >
                      Agregar
                    </Typography>
                  </Button>
                  <Button
                    onClick={() => navigate(-1)}
                    color="secondary"
                    sx={{ margin: "1%" }}
                    variant="contained">
                    <Typography
                      sx={{
                        color: "#ffffff",
                        "&:hover": {
                          color: "#15212f",
                        },
                        fontFamily: "MontserratRegular, sans-serif",
                        fontSize: "100%",
                      }}>
                      Cancelar
                    </Typography>
                  </Button>
                </Grid>
              </Box>
              <MUIXDataGrid id={Math.random} columns={columns} rows={rows} camposCsv={camposCsv} />
              <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box sx={style} display="flow">
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <Box>
                        <Typography variant="h5" sx={{ padding: "1%" }}>
                          {TITULODETALLE}
                        </Typography>
                      </Box>
                    </Grid>


                    <Grid item xs={6}>
                      <Box
                        component="form"
                        sx={{ "& > :not(style)": { m: 1.3, width: "100%" }, }}
                        noValidate
                        autoComplete="off"
                        display="flex"
                      >
                        <TextField
                          inputProps={{ maxLength: 256 }}
                          label="Texto"
                          size="small"
                          variant="outlined"
                          value={texto}
                          onChange={(v) => { setTexto(v.target.value); }}
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={6}>
                      <Box
                        component="form"
                        sx={{ "& > :not(style)": { m: 1.3, width: "100%" }, }}
                        noValidate
                        autoComplete="off"
                        display="flex"
                      >
                        <TextField
                          inputProps={{ maxLength: 256 }}
                          label="Link"
                          size="small"
                          variant="outlined"
                          value={link}
                          onChange={(v) => { setLink(v.target.value); }}
                        />
                      </Box>
                    </Grid>

                    <Grid container width={"100%"} justifyContent={"center"} xs={6} >
                      <Box
                        component="form"
                        sx={{ "& > :not(style)": { width: "100%" } }}
                        noValidate
                        autoComplete="off"
                        display="flex"
                      >
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={es_icono}
                              onChange={(e) => setEs_icono(e.target.checked)}
                              color="primary"
                            />
                          }
                          label="Es Icono"
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={6}>
                      <Box
                        component="form"
                        sx={{ "& > :not(style)": { width: "95%", ml: 1.5 } }}
                        noValidate
                        autoComplete="off"
                        display="flex"
                      >
                        <FormControl variant="outlined" size="small" fullWidth>
                          <Autocomplete
                            options={Object.values(ZonaEnum)} // Opciones basadas en el enum
                            getOptionLabel={(rol) => rol}
                            value={zona} // Valor seleccionado
                            onChange={(event, newValue) => {
                              setZona(newValue); // Actualiza el estado con el valor seleccionado
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                variant="outlined"
                                label="Rol de Zonas"
                                placeholder="Seleccione una Zona"
                                sx={{ height: "5rem" }}
                              />
                            )}
                            renderOption={(props, option) => (
                              <MenuItem {...props} key={option} value={option}>
                                {option}
                              </MenuItem>
                            )}
                            isOptionEqualToValue={(option, value) => option === value}
                          />
                        </FormControl>
                      </Box>
                    </Grid>


                    <Grid item xs={12}>
                      <Box
                        maxWidth="100%"
                        paddingTop={2}
                        paddingBottom={2}
                        display="flex"
                        justifyContent="end"
                      >
                        <Button
                          onClick={() => {
                            if (id === "") {
                              handleSave()
                            } else {
                              handleUpdate()
                            }
                          }
                          }
                          variant="contained"
                          sx={{ margin: "1%", color: "white", "&:hover": { color: "#15212f", }, }}
                        >
                          Guardar
                        </Button>
                        <Button
                          onClick={handleClose}
                          variant="contained"
                          color="secondary"
                          sx={{ margin: "1%", color: "white", "&:hover": { color: "#15212f", }, }}
                        >
                          Cancelar
                        </Button>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Modal>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Grid>
  );
}